module.exports = __webpack_public_path__ + "img/chocks.6baafadd.svg";